import React from 'react';
import { NavigateToRoot } from 'app/cross-cutting-concerns/authentication/components/NavigateToRoot/NavigateToRoot';

export const NoRouteFoundPage = (): JSX.Element => <NavigateToRoot />;
